/* tslint:disable */
import { chartEstimationData } from './chart-estimation-data';

/**
 */
export class ViewSizingEstimationResult_dataGraphChart {
    id?: number;
    equipName?: string;
    image?: string;
    data?: chartEstimationData;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-sizing-estimation-result-_data-graph-chart.ts